<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            
            <onboarding-header [step]="step"></onboarding-header>

            <div class="content mt-0 mt-md-3">
                <div class="animate__animated animate__slideInRight step-ready">

                    <h3 class="text-center">{{ 'onboarding.ready.description' | translate}}</h3>
                
                    <p class="text-center mt-3">{{ 'onboarding.ready.intro' | translate}}</p>
                
                
                    <div class="row mt-4">
                        <div class="col-md-10 mx-auto">
                            <div class="media">
                                <div class="media-body">
                                    <h4 class="media-heading">{{ 'onboarding.ready.notification.title' | translate}}</h4>
                                    <div class="row">
                                        <div class="col-md-8">
                                            <p class="text-justify">{{ 'onboarding.ready.notification.body' | translate}}</p>
                                        </div>
                                        <div class="col-md-4 pt-2">
                                            <a class="btn btn-primary btn-group-justified" data-cy="onboarding-ready-notify" (click)="notify()">
                                                <i class="fal fa-envelope"></i> {{'onboarding.ready.notification.cta' | translate}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                
                            <div class="media">
                                <div class="media-body">
                                    <h4 class="media-heading">{{ 'onboarding.ready.settings.title' | translate}}</h4>
                                    <div class="row">
                                        <div class="col-md-8">
                                            <p class="text-justify">{{ 'onboarding.ready.settings.body' | translate}}</p>
                                        </div>
                                        <div class="col-md-4 pt-2">
                                            <a
                                               [routerLink]="['/setup/teammembers', teamId]"
                                               data-cy="onboarding-ready-settings"
                                               class="btn btn-default btn-group-justified">
                                                <i class="fal fa-users"></i> {{ 'onboarding.ready.settings.cta' | translate}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                
                            <div class="media pb-4">
                                <div class="media-body">
                                    <h4 class="media-heading">{{ 'onboarding.ready.chat.title' | translate}}</h4>
                                    <div class="row">
                                        <div class="col-md-8">
                                            <p class="text-justify">{{ 'onboarding.ready.chat.body' | translate}}</p>
                                        </div>
                                        <div class="col-md-4 pt-2">
                                            <a class="btn btn-default btn-group-justified" data-cy="onboarding-ready-chat" (click)="chat()"><i class="fal fa-comments"></i> {{ 'onboarding.ready.chat.cta' | translate}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
